(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["teemixer-recipes"] && !Shopify.designMode) return;
  try {
    (function () {
    var RECIPES_KEY = 'teemixer:recipes';
    var NOT_READY_RETRY_MS = 1500;

    function readRecipes() {
      try {
        var list = JSON.parse(window.localStorage.getItem(RECIPES_KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    }

    function withParam(url, name, value) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + name + '=' + encodeURIComponent(value);
    }

    function amountText(line, config) {
      return line.amount + ' ' + (line.isCountUnit ? config.unitPiece : line.unit || 'g');
    }

    function idempotencyKey() {
      if (window.crypto && window.crypto.randomUUID) return 'tm-' + window.crypto.randomUUID();
      return 'tm-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    }

    // A blend dosed in drops is sent as the configurator sends it: the bottle, the drops and the
    // carrier that fills the rest (assets/teemixer.js, priceBody).
    function blendBody(recipe) {
      var body = {
        categoryId: recipe.categoryId,
        name: recipe.name || undefined,
        preparation: recipe.preparation || undefined
      };
      if (recipe.isDosedInDrops) {
        body.bottleSizeMl = recipe.bottleSizeMl;
        body.carrierProductId = recipe.carrierProductId || undefined;
        body.ingredients = recipe.lines.map(function (line) {
          return { productId: line.productId, drops: line.drops };
        });
        return body;
      }
      body.ingredients = recipe.lines.map(function (line) {
        return { productId: line.productId, amount: line.amount };
      });
      return body;
    }

    function mint(recipe, key, mayRetry) {
      return fetch(String(recipe.proxy || '').replace(/\/+$/, '') + '/blends', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Idempotency-Key': key
        },
        body: JSON.stringify(blendBody(recipe))
      }).then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            if (response.ok) return (body.data && body.data.attributes) || null;
            var code = body && body.errors && body.errors[0] ? body.errors[0].code : null;
            // Same as the configurator: the blend exists but its Shopify push
            // has not landed yet, and the same key returns that same blend.
            if (mayRetry && code === 'blend_not_ready') {
              return new Promise(function (resolve) {
                window.setTimeout(resolve, NOT_READY_RETRY_MS);
              }).then(function () {
                return mint(recipe, key, false);
              });
            }
            throw new Error(code || 'mint failed');
          });
      });
    }

    function addToCart(recipe, variantId, config) {
      var properties = {};
      if (recipe.name) properties[config.propBlend] = recipe.name;
      properties[config.propIngredients] = recipe.lines
        .map(function (line) {
          return line.name + ' ' + amountText(line, config);
        })
        .concat(recipe.carrierText ? [recipe.carrierText] : [])
        .join(' · ');
      if (recipe.preparation) properties[config.propPreparation] = recipe.preparation;
      if (recipe.name) properties._tm_name = recipe.name;
      properties._tm_summary = [config.cartLabel, recipe.artTitle, recipe.baseLabel, recipe.amountText]
        .filter(Boolean)
        .join(' · ');

      return fetch(config.cartAddUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        return response.json();
      });
    }

    // The theme's cart components re-render themselves on `cart:update`; no
    // productId in the payload, so the recommendations overlay stays shut.
    function announceCart(config) {
      return fetch(config.cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'teemixer-recipes',
                data: { source: 'teemixer-recipes', itemCount: cart.item_count }
              }
            })
          );
        });
    }

    function setNote(item, text, tone) {
      var note = item.querySelector('[data-note]');
      note.textContent = text || '';
      note.hidden = !text;
      if (tone) {
        note.setAttribute('data-tone', tone);
      } else {
        note.removeAttribute('data-tone');
      }
    }

    function orderAgain(recipe, item, button, config) {
      button.disabled = true;
      setNote(item, config.adding);
      mint(recipe, idempotencyKey(), true)
        .then(function (attributes) {
          if (!attributes || !attributes.variantId) throw new Error('no variant');
          return addToCart(recipe, attributes.variantId, config);
        })
        .then(function () {
          return announceCart(config);
        })
        .then(function () {
          // The drawer usually re-renders and replaces the item; where it does
          // not, the item must not stay stuck on "adding".
          button.disabled = false;
          setNote(item, '');
        })
        .catch(function () {
          button.disabled = false;
          setNote(item, config.failed, 'error');
        });
    }

    function render(root) {
      root.setAttribute('data-ready', '');
      var config;
      try {
        config = JSON.parse(root.querySelector('[data-tm-recipes-config]').textContent);
      } catch (error) {
        return;
      }

      var recipes = readRecipes().filter(function (recipe) {
        return recipe && recipe.lines && recipe.lines.length && recipe.proxy && recipe.url;
      });
      var list = root.querySelector('[data-tm-recipes-list]');
      var template = root.querySelector('[data-tm-recipes-item]');
      list.innerHTML = '';
      root.hidden = recipes.length === 0;
      if (!recipes.length) return;

      root.querySelector('[data-tm-recipes-new]').href = recipes[0].url;

      recipes.forEach(function (recipe) {
        var item = template.content.firstElementChild.cloneNode(true);
        var count = recipe.lines.length;
        item.querySelector('[data-name]').textContent = recipe.name || recipe.artTitle;
        item.querySelector('[data-meta]').textContent = [
          recipe.artTitle,
          recipe.baseLabel,
          count === 1 ? config.countOne : config.countOther.replace('%count%', count),
          recipe.amountText
        ]
          .filter(Boolean)
          .join(' · ');
        item.querySelector('[data-adjust]').href = withParam(recipe.url, 'tm_recipe', recipe.id);

        var again = item.querySelector('[data-again]');
        again.addEventListener('click', function () {
          orderAgain(recipe, item, again, config);
        });
        list.appendChild(item);
      });
    }

    function renderAll() {
      document.querySelectorAll('[data-tm-recipes]:not([data-ready])').forEach(render);
    }

    // Every cart change re-renders the drawer's section, which brings the
    // empty shell back; whatever lands in the DOM without `data-ready` is
    // filled again on the next frame.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        renderAll();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('storage', function (event) {
      if (event.key !== RECIPES_KEY) return;
      document.querySelectorAll('[data-tm-recipes]').forEach(function (root) {
        root.removeAttribute('data-ready');
      });
      renderAll();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', renderAll);
    } else {
      renderAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
